import { AlertCircle, Check } from "lucide-react";

export const VerifiedBadge = ({ verified }: { verified: boolean }) =>
  verified ? (
    <span className="inline-flex items-center gap-1.5 bg-[#EAF3DE] text-[#27500A] border border-[#97C459] rounded-xl px-3.5 py-1 
    text-sm font-medium whitespace-nowrap">
      <Check size={15} /> Verified
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5 bg-[#FAEEDA] text-[#633806] border border-[#EF9F27] rounded-xl  px-3.5 py-1 text-sm font-medium whitespace-nowrap">
      <AlertCircle size={15} /> Unverified
    </span>
  );